module.exports = __webpack_public_path__ + "img/UTANAS.795483e6.png";